import SettingsIndex from '@/views/settings/Index'
import YachtModelsIndex from '@/views/settings/yachtModels/Index'
import YachtEquipmentPacksIndex from '@/views/settings/yachtEquipmentPacks/Index'
import YachtEquipmentPackCategoriesIndex from '@/views/settings/yachtEquipmentPackCategories/Index'
import CountriesIndex from '@/views/settings/countries/Index'
import FinanceModels from '@/views/settings/financeModels/Index'
import YachtEnginesIndex from '@/views/settings/yachtEngines/Index'
import YachtManufacturersIndex from '@/views/settings/yachtManufacturers/Index'
import YachtTypesIndex from '@/views/settings/yachtTypes/Index'
import DocumentTemplatesIndex from '@/views/settings/documentTemplates/Index'
import NavigareCompaniesIndex from '@/views/settings/navigareCompanies/Index'
import CurrencyExchangeRatesIndex from '@/views/settings/currencyExchangeRates/Index'
import YachtFinancialsIndex from '@/views/settings/yachtFinancials/Index'
import CostControlIndex from '@/views/settings/costControl/Index'
import StaffIndex from '@/views/business/staff/Index'
import ContractorsIndex from '@/views/business/contractors/Index'
import BasesIndex from '@/views/business/bases/Index'
import ServiceTasksRepositoryIndex from '@/views/settings/serviceTasksRepository/Index'
import RolesIndex from '@/views/settings/roles/Index'
import MarginsIndex from '@/views/settings/margins/Index'
import PricelistIndex from '@/views/settings/pricelists/PricelistIndex'

export default [
  {
    path: '/settings',
    name: 'settings',
    redirect: { name: 'yachtModels' },
    component: SettingsIndex,
    children: [
      {
        path: 'yacht-models',
        name: 'yachtModels',
        component: YachtModelsIndex
      },
      {
        path: 'yacht-financials',
        name: 'yachtFinancials',
        component: YachtFinancialsIndex
      },
      {
        path: 'cost-control',
        name: 'costControl',
        component: CostControlIndex
      },
      {
        path: 'yacht-equipment-packs',
        name: 'yachtEquipmentPacks',
        component: YachtEquipmentPacksIndex
      },
      {
        path: 'yacht-equipment-pack-categories',
        name: 'yachtEquipmentPackCategories',
        component: YachtEquipmentPackCategoriesIndex
      },
      {
        path: 'financing',
        name: 'financeModels',
        component: FinanceModels
      },
      {
        path: 'yacht-types',
        name: 'yachtTypes',
        component: YachtTypesIndex
      },
      {
        path: 'yacht-engines',
        name: 'yachtEngines',
        component: YachtEnginesIndex
      },
      {
        path: 'yacht-manufactures',
        name: 'yachtManufactures',
        component: YachtManufacturersIndex
      },
      {
        path: 'countries',
        name: 'countries',
        component: CountriesIndex
      },
      {
        path: 'staff',
        name: 'staff',
        component: StaffIndex
      },
      {
        path: 'contractors',
        name: 'contractors',
        component: ContractorsIndex
      },
      {
        path: 'bases',
        name: 'bases',
        component: BasesIndex
      },
      {
        path: 'document-templates',
        name: 'documentTemplates',
        component: DocumentTemplatesIndex
      },
      {
        path: 'navigare-companies',
        name: 'navigareCompanies',
        component: NavigareCompaniesIndex
      },
      {
        path: 'currency-exchange-rates',
        name: 'currencyExchangeRates',
        component: CurrencyExchangeRatesIndex
      },
      {
        path: 'service-tasks-repository',
        name: 'serviceTasksRepository',
        component: ServiceTasksRepositoryIndex
      },
      {
        path: 'roles',
        name: 'roles',
        component: RolesIndex
      },
      {
        path: 'margins',
        name: 'margins',
        component: MarginsIndex
      },
      {
        path: 'booking-pricelist',
        name: 'bookingPricelist',
        component: PricelistIndex
      }
    ]
  }
]
